import { createContext, useContext } from 'react'
import { useMessagesScreenData } from './hooks/useMessagesScreenData'

export type MessagesContextType = ReturnType<typeof useMessagesScreenData>

export const MessagesScreenContext = createContext<MessagesContextType>({} as MessagesContextType)

export const useMessages = () => useContext(MessagesScreenContext)
